const initialState = {
  menu: {type: null, payload: null},
  isMenuFetched: false,
  isMenuLoaded: false,
  addedItems: [],
};

export default initialState;
